import React from "react";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import siteConfig from "../config/siteConfig";
import { productImageSrcSet } from "../utils/images";
import "../css/editorial-pages.scss";
import CommercialInquiryForm from "./CommercialInquiryForm";
import PageMeta from "./PageMeta";
import ProductCard from "./ProductCard";

const giftProductIds = [19, 21, 11];

function Gifts() {
  const giftProducts = giftProductIds
    .map((id) => productData.find((product) => product.id === id))
    .filter(Boolean);

  return (
    <main className="content-page editorial-page commercial-page gifts-page">
      <PageMeta
        title="Corporate gifts"
        description={`Thoughtful Italian pantry gifts for teams, clients, and celebrations from ${siteConfig.brandName}.`}
      />

      <header className="commercial-hero commercial-hero--gifts">
        <div className="page-shell commercial-hero__grid">
          <div className="commercial-hero__copy">
            <p className="eyebrow">Corporate gifts</p>
            <h1>Send something they will actually open.</h1>
            <p>
              Italian pantry gifts with warmth, useful ingredients, and enough
              personality to feel chosen—not pulled from a generic catalog.
            </p>
            <a className="button button--primary" href="#gift-inquiry">
              Plan a gift
            </a>
          </div>
          <div className="commercial-hero__media">
            <img
              src="/img/product-21.jpg"
              srcSet={productImageSrcSet("/img/product-21.jpg")}
              sizes="(max-width: 760px) 100vw, 50vw"
              alt="Italian sweets arranged as a generous food gift"
              width="1200"
              height="1200"
              loading="eager"
            />
            <p>For teams · clients · hosts · milestones</p>
          </div>
        </div>
      </header>

      <section className="page-section page-shell" aria-labelledby="gift-service-title">
        <div className="section-heading commercial-heading">
          <p className="eyebrow">Made useful, made personal</p>
          <h2 id="gift-service-title">A generous pantry, thoughtfully edited</h2>
          <p>
            Start with a ready-to-give assortment or let us shape a collection
            around your recipients, timing, and budget.
          </p>
        </div>
        <div className="commercial-service-grid">
          <article>
            <span>01</span>
            <h3>Curated assortments</h3>
            <p>Balanced combinations of dinner staples, sweets, and celebratory bottles.</p>
          </article>
          <article>
            <span>02</span>
            <h3>Personal notes</h3>
            <p>Recipient-ready messaging keeps every gift connected to the occasion.</p>
          </article>
          <article>
            <span>03</span>
            <h3>Multiple addresses</h3>
            <p>A future fulfillment handoff can support one destination or a whole team.</p>
          </article>
          <article>
            <span>04</span>
            <h3>Clear planning</h3>
            <p>Quantity, timing, and budget are considered before the final assortment.</p>
          </article>
        </div>
      </section>

      <section className="page-section commercial-products" aria-labelledby="gift-products-title">
        <div className="page-shell">
          <div className="commercial-products__header">
            <div className="section-heading">
              <p className="eyebrow">A taste of the assortment</p>
              <h2 id="gift-products-title">Pantry favorites worth sharing</h2>
            </div>
            <Link className="commercial-text-link" to="/shop">
              Shop all products <span aria-hidden="true">→</span>
            </Link>
          </div>
          <div className="commercial-product-grid">
            {giftProducts.map((product) => (
              <ProductCard product={product} key={product.id} tone="cream" />
            ))}
          </div>
        </div>
      </section>

      <section className="page-section page-shell commercial-process" aria-labelledby="gift-process-title">
        <div className="section-heading">
          <p className="eyebrow">How it comes together</p>
          <h2 id="gift-process-title">Three clear steps to a better gift</h2>
        </div>
        <ol>
          <li><strong>Share the occasion.</strong><span>Tell us who, how many, when, and approximately what you would like to spend.</span></li>
          <li><strong>Shape the pantry.</strong><span>A future gifting specialist can recommend an assortment and practical delivery plan.</span></li>
          <li><strong>Confirm the details.</strong><span>Review recipients, notes, and timing before any order is finalized.</span></li>
        </ol>
      </section>

      <section className="commercial-inquiry" id="gift-inquiry" aria-labelledby="gift-inquiry-title">
        <div className="page-shell commercial-inquiry__grid">
          <div className="commercial-inquiry__intro">
            <p className="eyebrow">Begin an inquiry</p>
            <h2 id="gift-inquiry-title">Tell us what you are celebrating.</h2>
            <p>
              This polished front-end flow is ready to connect to a secure CRM
              or form endpoint when the store adds a back end.
            </p>
          </div>
          <CommercialInquiryForm type="gifts" />
        </div>
      </section>
    </main>
  );
}

export default Gifts;
